import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';

import './questionPaper.css';

const ExamPatternPopup = (props) => {
    const { lstPattern, subjectId, subject, patternId, handlePatternIdChange, closePopup } = props;

    const [selPatternId, setSelPatternId] = useState(0);
    const [editLoader, setEditLoader] = useState("none");
    const [editOpacity, setEditOpacity] = useState(1);
    const [lstPatternFiltered, setLstPatternFiltered] = useState([]);
    const [patternFiltered, setPatternFiltered] = useState("");
    const [maxMarksFiltered, setMaxMarksFiltered] = useState("");



    useEffect(() => {
        // console.log("ExamPatternPopup called");
        setLstPatternFiltered(lstPattern);
    }, [lstPattern]);

    useEffect(() => {
        // console.log("ExamPatternPopup called");
        setSelPatternId(patternId);
    }, [subjectId, patternId]);


    const colgrp = <colgroup>
        <col width="60"></col>
        <col width="20"></col>
        <col width="20"></col>
        <col width="40"></col>
    </colgroup>


    return (
        <div className='exam-subject-pattern-popup'>
            <div style={{
                position: 'fixed',
                zIndex: 10000,
                width: 100,
                height: 100,
                marginLeft: -50,
                marginTop: -50,
                left: '58%',
                top: '45%',
                display: editLoader
            }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <div
                className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: editLoader === "none" ? 'pointer' : 'none',
                    pointerEvents: editLoader === "none" ? 'auto' : 'none',
                    opacity: editOpacity,
                }}
            ></div>
            <button
                type="button"
                className="btn btn-info exam-pattern-popup-close"
                onClick={() => closePopup()}
            >
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div className='col-md-12 col-sm-12 col-xs-12 padding-remove'>
                <div className='col-md-9 col-sm-9 col-xs-9 padding-remove'>
                    Select Pattern for {subject}
                </div>
            </div>
            <div className="col-md-12 col-xs-12 col-sm-12 col-centered padding-remove" style={{ marginTop: "50px" }}>
                <table className="tableLayout1">
                    {colgrp}
                    <thead>
                        <tr>
                            <th className="text-center">Pattern</th>
                            <th className="text-center">Max. Marks</th>
                            <th className="text-center">Section</th>
                            <th className="text-center">Pattern Date</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "200px" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="ExamSubjectPatternPopupTable">
                            {lstPatternFiltered &&
                                lstPatternFiltered.map((pattern, i) => (
                                    <tr
                                        key={pattern.patternId}
                                        onClick={() => handlePatternIdChange(subjectId, pattern.patternId, pattern.pattern, pattern.noOfSections)}
                                        className={pattern.patternId === selPatternId ? "selected" : ""}
                                    >
                                        <td className="text-left">{pattern.pattern}</td>
                                        <td className="text-center">{pattern.maxMarks}</td>
                                        <td className="text-center">{pattern.noOfSections}</td>
                                        <td className="text-center">{pattern.patternDttm}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    )
}

export default ExamPatternPopup;
